import React, {Fragment} from 'react';
import Box from '../layout/Box';
import TextInput from '../form/TextInput';
import TextArea from '../form/TextArea';
import createEditor from '../form/ComponentEditor';
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import classNames from "classnames";
import ComponentField from "../form/ComponentField";
import MembercardForm from "./forms/MembercardForm";
import MembercardList from "./lists/MembercardList";
import BoxEditor from "./BoxEditor";
import Button from "../form/Button";

class MembercardEditor extends React.Component {

    loadForm = async (data) => {
        await this.props.loadForm(data);
        this.editor && this.editor.focus();
    }

    pristineForm = async () => {
        await this.props.pristineForm();
        this.editor && this.editor.focus();
    }

    saveForm = async (event) => {
        await this.props.saveForm(event);
        this.list && this.list.refresh();
    }

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        return (
            <Fragment>
                <List
                    {...this.props}
                    collapsed={this.props.collapsed || false}
                    theme="default"
                    header="Törzsvásárló kártyák"
                >
                    <MembercardList ref={(el) => this.list = el} {...this.props} loadForm={this.loadForm} />
                </List>
                <Editor
                    {...this.props}
                    ref={(editor) => this.editor = editor}
                    theme="default"
                    header="Törzsvásárló kártya"
                >
                    <MembercardForm {...this.props} />
                </Editor>
            </Fragment>
        );
    }
}
export default createEditor({
    componentName: "Membercard",
    WrappedComponent: MembercardEditor,
    props: {
        view: "admin"
    }
});

